'use client';

import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';

interface FormSuccessStepProps {
  /** Optional custom warning message (defaults to "Do not close this page before confirming.") */
  warningMessage?: string;
  /** Optional custom title (defaults to the standard confirmation message) */
  title?: React.ReactNode;
  /** Optional custom description paragraphs */
  description?: {
    first?: string;
    second?: string;
  };
  /** Optional className for the container */
  className?: string;
  textCentered?: boolean;
}

export default function FormSuccessStep({
  warningMessage = 'YOUR SPOT IS NOT YET CONFIRMED',
  title,
  description,
  className = '',
}: FormSuccessStepProps) {
  const defaultTitle = (
    <>
      <span className="font-instrument-serif italic text-offwhite">
        CHECK YOUR INBOX NOW
      </span>{' '}
      & CONFIRM YOUR SPOT ON THE WAITLIST.
    </>
  );

  const defaultDescription = {
    first:
      "To protect the waitlist & first 100 from bots, we've sent a verification link to your email under the subject” VEYLOR: Confirm your spot on the waitlist”. The email can beetwen 10 seconds & 5 minutes to land in your account. Make sure to check your spam & promotions tab due to email provider automatic filters.",
    second:
      'You must click it to confirm your spot and receive the early access password.',
  };

  return (
    <motion.div
      key="success-step"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      className={cn(
        'flex flex-col gap-[4rem] lg:gap-[3rem] items-start w-full',
        className,
      )}
    >
      {/* Warning Box */}
      <div className="border-gradient-red relative bg-[rgba(119,57,49,0.18)] w-fit rounded-[0.64rem] p-[2rem]">
        <p className="text-[2rem] font-inter-tight text-[#D3AAA5] leading-none">
          {warningMessage}
        </p>
      </div>

      {/* Success Message */}
      <div className="flex flex-col gap-[5rem] lg:gap-[2rem]">
        <h2 className="text-[5rem] lg:text-[6rem] font-inter-tight text-[rgba(218,218,218,0.72)] leading-[1.1] uppercase">
          {title || defaultTitle}
        </h2>
        <div className="flex flex-col gap-[2rem] text-[1.6rem] leading-[160%] font-[300] lg:text-[2rem] text-offwhite/80 font-inter-tight">
          <p>{description?.first || defaultDescription.first}</p>
          <p className="text-offwhite font-bold">
            {description?.second || defaultDescription.second}
          </p>
        </div>
      </div>
    </motion.div>
  );
}
